/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const VectorStoresGroupBy = {
  UserId: "user_id",
  ApiKeyId: "api_key_id",
} as const;
export type VectorStoresGroupBy = ClosedEnum<typeof VectorStoresGroupBy>;

/** @internal */
export const VectorStoresGroupBy$inboundSchema: z.ZodNativeEnum<
  typeof VectorStoresGroupBy
> = z.nativeEnum(VectorStoresGroupBy);
/** @internal */
export const VectorStoresGroupBy$outboundSchema: z.ZodNativeEnum<
  typeof VectorStoresGroupBy
> = VectorStoresGroupBy$inboundSchema;
